<template>
  <div class="border-2 overflow-hidden relative" :class="isCircle ? 'rounded-full' : 'rounded-none'"
    style="width: 100%; height: 0; box-sizing: border-box;background-color: #ccc;"
    :style="{ paddingBottom: `${(vertical / horizontal) * 100}%` }">
    <div class="full-height absolute full-width -translate-y-1/2 -translate-x-1/2 left-1/2 top-1/2" :style="{
      width: isCircle ? `${(horizontal / diameter) * 100}%` : '100%',
      height: isCircle ? `${(horizontal / diameter) * 100}%` : '100%'
    }">
      <div v-for="item in eqPoints" :key="item.eqId" style="position: absolute; height: 0;" :style="{
        width: `${(item.eqinfo.side / item.eqinfo.width) * 100}%`,
        left: `${getMinX(
          item.eqinfo.left,
          item.eqinfo.side,
          item.eqinfo.width
        ) * 100}%`,
        top: `${getMinY(
          item.eqinfo.top,
          item.eqinfo.side,
          item.eqinfo.height
        ) * 100}%`,
        height: `${(item.eqinfo.side / item.eqinfo.height) * 100}%`
      }">
        <div class="relative" :style="{
          width: '100%',
          height: 0,
          height: '100%'
        }">
          <div class="grid full-height absolute full-width" :style="{
            gridTemplateColumns: `repeat(${item.eqinfo.side}, minmax(0, 1fr))`,
            gridTemplateRows: `repeat(${item.eqinfo.side}, minmax(0, 1fr))`,
            gap: '2px'
          }">
            <tk-flex middle center class="test-point cursor-pointer" :class="canClassification
                ? selectPoints.includes(it.originalId)
                  ? 'select'
                  : it.test.hasResult
                    ? it.test.pass ? 'noresult' :
                      it.test.count > 0
                        ? 'hasbug'
                        : 'nobug'
                    : 'noresult'
                : 'nobug'
              " v-for="it in item.points" :key="it.index" @click.native="$emit('changePoints', it.originalId)">
              <a-popover v-if="canPopUp" :title="`粮虫总计: ${it.test.hasResult ? it.test.pass ? '-' : it.test.count : '-'}`">
                <template slot="content">
                  <div style="font-size: 14px;color:#666A70;">
                    <tk-flex between style="width: 200px;">
                      <div>象甲科(米象、玉米象等)</div>
                      <div>--</div>
                    </tk-flex>
                    <tk-flex between style="width: 200px;">
                      <div>拟步甲科等（谷盗等）</div>
                      <div>--</div>
                    </tk-flex>
                    <tk-flex between style="width: 200px;">
                      <div>飞蚁科</div>
                      <div>--</div>
                    </tk-flex>
                    <tk-flex between style="width: 200px;">
                      <div>飞蛾科</div>
                      <div>--</div>
                    </tk-flex>
                    <tk-flex between style="width: 200px;">
                      <div>飞蛾幼虫类</div>
                      <div>--</div>
                    </tk-flex>
                    <tk-flex between style="width: 200px;">
                      <div>未识别害虫</div>
                      <div>--</div>
                    </tk-flex>
                  </div>
                </template>
                <tk-flex middle center style="width: 100%;height: 100%;">{{
                  it.index
                }}</tk-flex>
              </a-popover>
              <div v-else>{{ it.index }}</div>
            </tk-flex>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    canPopUp: {
      type: Boolean,
      default: true
    },
    canClassification: {
      type: Boolean,
      default: true
    },
    horizontal: {
      type: Number,
      required: true
    },
    vertical: {
      type: Number,
      required: true
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    diameter: {
      type: Number,
      default: 0
    },
    eqPoints: {
      type: Array,
      required: true
    },
    selectPoints: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getMinX (left, size, length) {
      return (left - Math.floor(size / 2)) / length
    },
    getMinY (top, size, length) {
      return (top - Math.floor(size / 2)) / length
    }
  }
}
</script>
<style lang="scss" scoped>
.test-point {
  &.select {
    background-color: #ffa000;
  }

  &.hasbug {
    background-color: #ffe6bc;
  }

  &.nobug {
    background-color: #fff;
  }

  &.noresult {
    background-color: #eee;
  }
}
</style>
